module.exports = __webpack_public_path__ + "img/dyd.32642470.png";